import * as React from 'react';
import { DataTable } from 'damco-components';
import { ICostBooking } from 'reducers/bookings/models';
import { StatusRow } from 'components/status-row';
import { LoadingAnimation } from 'components/loading';
import { InPageDialog } from 'damco-components';
import { ModalMain } from 'damco-components';
import { DataList } from 'components/select-advanced';
import {
  FinOpsStatusPermission,
  FinOpsStatusSalesOrder,
  checkIfSystemType,
  calculateTotalOfField,
  checkLinkedState,
  originDestinationCols,
} from '../../../views/job-costing/utils/CostAndRevenueHelpers';
import * as validationMessages from 'constants/validationMessages';
import {
  FinOpsStatus,
  ITableSelected,
} from '../../../views/job-costing/utils/models';
import { ItemCategoryCheck } from 'modules/cost-revenue/component/ItemCategoryCheck';
import { getReasonCodes } from 'actions/mdm';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { isFeatureEnabled, mapReasonCodesToOptions } from 'utilities/util';
import { localCurrency, pageName } from 'constants/customs';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { fetchCustomerToggles } from 'actions/customerToggle';
import { ICustomerToggleModel } from 'reducers/customerToggle/models';
import { fetchReconciliationPODetails } from 'actions/exportJob';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import {
  setVatPartnersTableData,
  fetchVatPartners,
  fetchVatPartnerEditReasons,
} from 'actions/vat-partner-edit';
import { ATHENA } from 'constants/messages';
import { getAllBillToParties } from 'actions/bill-to-party';
import { redirectToCombineInvoice } from 'utilities/route-utils';
import AddChargeAgain from './AddChargeAgain';
import { BLOCKED_TYPES } from 'constants/blockedTypes';
import {
  InvoiceValidationModal,
  IInvoiceValidationError,
} from './InvoiceValidationModal';
import { callApiV3Post } from 'utilities/apiCaller';
import API from 'constants/api';
import { Button, ButtonType } from 'components/button/index';
import {
  setRowData,
  setTargetType,
  setJobId,
  setTarget,
  setEditVatMode,
  setEditVatOnlyMode,
} from 'actions/editBillToPartyAndVatPartner';
interface IBookingsTableProps {
  id: string;
  isDestination: boolean;
  finOpsStatus: string[];
  data: ICostBooking[];
  subCols: any[];
  isLoading: boolean;
  isEditable: boolean;
  isExpandable?: boolean;
  tableTitle: string;
  labelAddAction: string;
  validationError?: any;
  type: string;
  readOnly: boolean;
  showInvoices: boolean;
  showVatPartnersEdit: boolean;
  forceFooterUpdate: boolean;
  addAction: (e: any) => void;
  editAction: (e: any) => void;
  retrieveAction?: () => void;
  linkAction?: (e: any) => void;
  fetchData?: (s: any, t: any, dataType?: string) => void;
  vatPartnersEdit?: () => void;
  billToPartyEdit?: () => void;
  setSelectedInvoices?: (props: any) => void;
  deleteAction: (e: any, reason: string) => void;
  funcName: string;
  isReceivingFCR: boolean;
  isJobClosed?: boolean;
  salesOrderResponse: any;
  isSourceAthena?: boolean;
  vendorsData?: any;
  isNftpBillable?: boolean;
  isNftpRoeEnabled?: boolean;
}
interface IState {
  localData: any[];
  validReason: boolean;
  isDelete: boolean;
  isInvoice: boolean;
  isInvoiceError: boolean;
  actions: any;
  showDialog: boolean;
  showModal: boolean;
  showErrorModal: boolean;
  errorMessage: string;
  hasPaging: boolean;
  refData: any[];
  reasonCodeSelected: string;
  // tslint:disable: no-empty
  getSelectedItems: () => void;
  setSelectedItems: () => void;
  isDifferentFunc: boolean;
  isAthenaAmendment: boolean;
  showEditVatPartnersModal: boolean;
  showEditBillToPartyModal: boolean;
  ignoreOnRefresh: string;
  ignoreOnRefreshRequired: boolean;
  showAmendMentError: boolean;
  showDifferentTypeSelectionError: boolean;
  showInvoiceBlockedError: boolean;
  showZeroLocalAmountError: boolean;
  allowBillToPartyEdit: boolean;
  showFrnReadOnlyError: boolean;
  showFrnMixedDivisionError: boolean;
  showMciDivisionDeleteError: boolean;
  showVatPartnerPermissionError: boolean;
  showInvoiceValidationModal: boolean;
  invoiceValidationErrors: IInvoiceValidationError[];
  isValidatingInvoice: boolean;
  isMciFlow: boolean;
  showIcpVatPartnerChoiceModal: boolean;
}

interface IMapDispatchToProps {
  getReasonCodes: (category: string) => Promise<void>;
  fetchCustomerToggles: (customerBeCode: string) => Promise<void>;
  fetchReconciliationPODetails: (
    exportJobId: number,
    catagory: number,
  ) => Promise<void>;
  setVatPartnersTableData: (data: any) => void;
  fetchVatPartners: () => void;
  fetchVatPartnerEditReasons: () => void;
  getAllBillToPartiesAction: (searchId: number, level: number) => Promise<void>;
  setRowData: (data: any) => void;
  setTargetType: (targetType: string) => void;
  setJobId: (idJob: number) => void;
  setTarget: (target: string | number) => void;
  setEditVatMode: (editVatMode: boolean) => void;
  setEditVatOnlyMode?: (editVatOnlyMode: boolean) => void;
}
interface IMapStateToProps {
  reasonCodes: any[];
  featureToggles: IFeatureToggleModel[];
  billToPartnersRawData: any[];
  customerToggle: ICustomerToggleModel[];
  reconsiliationPODetails: any;
  userPermissions: any;
  etsNumber: any;
  exportJobNumber: any;
  etsDocumentNumber: any;
  exportDocumentNumber: any;
  originCompanyCode: string;
  destinationCompanyCode: string;
  etsRateErrorMessage: any;
  exportRateErrorMessage: any;
}

interface IProperties
  extends IBookingsTableProps, IMapDispatchToProps, IMapStateToProps {}

// Module-level: shared across the Revenue and Cost CostRevTable instances on the same page
// so that only one of them dispatches fetchCustomerToggles when billToPartnersRawData arrives.
let _customerToggleFetchKey = '';

export class _CostRevTable extends React.Component<IProperties, IState> {
  // public retrieveBtn:any = this.props.retrieveAction?{ isMoreBtn: false, label: 'Retrieve something', action: () => this.props.retrieveAction()}:{};
  public secondaryStates: any[] = []; // [...this.retrieveBtn]
  public editBtn: any = {
    isMoreBtn: false,
    label: 'Edit',
    action: () => this.editFc(),
  };
  public invoiceBtn: any = {
    isMoreBtn: false,
    label: 'Issue Invoice',
    action: () => this.issueFc(),
  };
  public deleteBtn: any = {
    isMoreBtn: false,
    label: 'Delete',
    action: () => this.checkDeletePermission(),
  };
  public myReason = React.createRef<any>();
  public state: IState = {
    localData: [],
    validReason: true,
    isDelete: false,
    isInvoiceError: false,
    isInvoice: false,
    reasonCodeSelected: '',
    actions: {
      primaryActionIsMoreBtn: false,
      primaryActionLabel: this.props.labelAddAction,
      primaryAction: () => this.addFc(),
      secondaryActions: this.secondaryStates,
      parentContextualActions: [this.deleteBtn, this.editBtn],
    },
    showDialog: false,
    showErrorModal: false,
    showModal: false,
    errorMessage: '',
    hasPaging: true,
    refData: [],
    // tslint:disable: no-empty
    getSelectedItems: () => {},
    setSelectedItems: () => {},
    isDifferentFunc: false,
    isAthenaAmendment: false,
    showEditVatPartnersModal: false,
    showEditBillToPartyModal: false,
    ignoreOnRefresh: '',
    ignoreOnRefreshRequired: false,
    showAmendMentError: false,
    showDifferentTypeSelectionError: false,
    showInvoiceBlockedError: false,
    showZeroLocalAmountError: false,
    allowBillToPartyEdit: false,
    showFrnReadOnlyError: false,
    showFrnMixedDivisionError: false,
    showMciDivisionDeleteError: false,
    showVatPartnerPermissionError: false,
    showInvoiceValidationModal: false,
    invoiceValidationErrors: [],
    isValidatingInvoice: false,
    isMciFlow: false,
    showIcpVatPartnerChoiceModal: false,
  };
  public selectTable: any = React.createRef();
  public refTable: any = React.createRef();

  public componentDidMount = () => {
    if (this.props.type === 'REV') {
      this.checkInvoices();
    }
    if (this.props.data && this.props.data.length === 0) {
      this.setState({ hasPaging: false });
    } else {
      this.setState({ localData: this.props.data });
      this.setState({ hasPaging: true });
    }
    const category = this.props.isDestination ? 'ISSO' : 'ESSO';
    this.props.getReasonCodes(category);
    const isPoReconciliationEnabled = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_RECONCILIATION,
      this.props.featureToggles,
    );

    if (this.isExportJobsDetails() && isPoReconciliationEnabled) {
      this.props.fetchReconciliationPODetails(
        Number(this.props.vendorsData.costAndRevenueId),
        0,
      );
    }
    if (this.isEtsDetails() && isPoReconciliationEnabled) {
      this.props.fetchReconciliationPODetails(
        Number(this.props.vendorsData.costAndRevenueId),
        1,
      );
    }
    if (
      this.props.vendorsData?.costAndRevenueId &&
      this.props.vendorsData?.targetId
    ) {
      this.props.getAllBillToPartiesAction(
        this.props.vendorsData.costAndRevenueId,
        Number(this.props.vendorsData.targetId),
      );
    }
  };
  public componentWillUnmount = () => {
    _customerToggleFetchKey = '';
  };
  public componentDidUpdate = (prevProps: any, prevState: any) => {
    if (this.props.showInvoices !== prevProps.showInvoices) {
      this.checkInvoices();
    }
    if (prevProps.data !== this.props.data) {
      this.setState({ localData: this.props.data });
      this.updateFooter();
      this.addEventHandler();
    }
    if (
      prevProps.forceFooterUpdate !== this.props.forceFooterUpdate &&
      this.props.forceFooterUpdate
    ) {
      this.updateFooter();
    }
    if (
      (this.props.reconsiliationPODetails !==
        prevProps.reconsiliationPODetails ||
        this.props.data !== prevProps.data) &&
      this.props.reconsiliationPODetails?.length &&
      this.props.data?.length
    ) {
      this.setData(this.props.data);
    }
    if (
      prevProps.billToPartnersRawData !== this.props.billToPartnersRawData &&
      this.props.billToPartnersRawData?.length > 0
    ) {
      const consignee = this.props.billToPartnersRawData
        .filter((partner: any) => partner.partnerType === 'Consignee')
        .map(
          (partner: any) =>
            `${partner.country}${partner.beCode}${partner.funcCode}`,
        );
      if (consignee.length && consignee[0] !== _customerToggleFetchKey) {
        _customerToggleFetchKey = consignee[0];
        this.props.fetchCustomerToggles(consignee[0]);
      }
    }
  };

  public checkInvoices = () => {
    const actions = { ...this.state.actions };
    if (this.props.type === 'REV') {
      if (
        this.props.showInvoices &&
        actions.parentContextualActions.length === 2
      ) {
        actions.parentContextualActions.push(this.invoiceBtn);
        this.setState({ actions });
      } else if (
        !this.props.showInvoices &&
        actions.parentContextualActions.length === 3
      ) {
        delete actions.parentContextualActions[2];
        this.setState({ actions });
      }
    }
  };

  public extractDynamicFieldValues = (dynamicFields: string) => {
    if (!dynamicFields) {
      return '';
    }
    try {
      const parsedFields = JSON.parse(dynamicFields);
      if (Array.isArray(parsedFields)) {
        return parsedFields.map((field) => field.value).join(', ');
      } else {
        console.error('dynamicFields is not an array', dynamicFields);
        return '';
      }
    } catch (error) {
      console.error('Error parsing dynamic fields', error);
      return '';
    }
  };

  public handleIgnoreOnRefreshChange = (value: string) => {
    this.setState({ ignoreOnRefresh: value, ignoreOnRefreshRequired: !value });
  };

  public render() {
    const tableRowData = this.state.localData;
    const columns = this.getCols().filter((col: any) => col.show);
    // DataTable snapshots props.columns in componentWillMount and never re-reads it,
    // so columns that turn on later (4PL, gated on the async customerToggle fetch)
    // only appear if the table is remounted when the column set changes.
    const columnSignature = columns.map((col: any) => col.accessor).join('|');
    return (
      <div>
        <InPageDialog
          showDialog={this.state.showDialog}
          type={'error'}
          message={this.state.errorMessage}
          closeMethod={() =>
            this.setState({ showDialog: false, errorMessage: '' })
          }
        />
        <ItemCategoryCheck
          displayDialog={this.state.showErrorModal}
          message={this.getEditMsg()}
          closeDialog={() =>
            this.setState({
              showErrorModal: false,
              isDelete: false,
              isInvoice: false,
              isInvoiceError: false,
              isDifferentFunc: false,
              showAmendMentError: false,
              showDifferentTypeSelectionError: false,
              showInvoiceBlockedError: false,
              showZeroLocalAmountError: false,
              showFrnReadOnlyError: false,
              showFrnMixedDivisionError: false,
              showMciDivisionDeleteError: false,
              showVatPartnerPermissionError: false,
            })
          }
        />
        <InvoiceValidationModal
          displayDialog={this.state.showInvoiceValidationModal}
          errors={this.state.invoiceValidationErrors}
          isDestination={this.props.isDestination}
          closeDialog={() =>
            this.setState({
              showInvoiceValidationModal: false,
              invoiceValidationErrors: [],
            })
          }
        />
        {!this.state.showErrorModal && (
          <ModalMain
            height={300}
            modal={this.state.showModal}
            title={validationMessages.CostAndRevenue.Delete_Charge}
            hideMethod={() =>
              this.setState({
                showModal: false,
                isDelete: false,
                reasonCodeSelected: '',
                ignoreOnRefresh: '',
              })
            }
            secondaryMethod={() =>
              this.setState({
                showModal: false,
                isDelete: false,
                reasonCodeSelected: '',
                ignoreOnRefresh: '',
              })
            }
            primaryMethod={() => {
              this.deleteFc(this.state.ignoreOnRefresh);
            }}
            btnTitle1={'OK'}
            btnTitle2={'Cancel'}
          >
            {validationMessages.CostAndRevenue.Alert_Page_Delete}
            {this.getReasonCodes()}
            {this.showIgnoreOnRefreshSelection() && (
              <AddChargeAgain
                show={this.state.showModal}
                required={this.state.ignoreOnRefreshRequired}
                onIgnoreOnRefreshChange={this.handleIgnoreOnRefreshChange}
              />
            )}
          </ModalMain>
        )}
        {this.state.showEditVatPartnersModal &&
          !this.state.allowBillToPartyEdit && (
            <ModalMain
              height={300}
              modal={this.state.showEditVatPartnersModal}
              title={'Operation not possible'}
              hideMethod={() =>
                this.setState({ showEditVatPartnersModal: false })
              }
              secondaryMethod={() =>
                this.setState({ showEditVatPartnersModal: false })
              }
              primaryMethod={() => {
                this.setState({ showEditVatPartnersModal: false });
                this.vatPartnersEditAction();
              }}
              btnTitle1={'Edit VAT Partners'}
              btnTitle2={'Cancel'}
            >
              <p>{validationMessages.CostAndRevenue.Error_Athena_Amendment}</p>
              <p>
                If you wish to edit only the VAT partners, please click 'Edit
                VAT Partners' to continue. If you wish to cancel, click 'Cancel'
                to remain on the current page.
              </p>
            </ModalMain>
          )}
        {this.state.allowBillToPartyEdit && (
          <ModalMain
            height={300}
            modal={this.state.allowBillToPartyEdit}
            title={'Operation not possible'}
            hideMethod={() =>
              // also clear showEditVatPartnersModal so the stale flag doesn't trigger that modal next render
              this.setState({ allowBillToPartyEdit: false, showEditVatPartnersModal: false })
            }
            secondaryMethod={() =>
              this.setState({ allowBillToPartyEdit: false, showEditVatPartnersModal: false })
            }
            primaryMethod={() => {
              this.setState({ allowBillToPartyEdit: false });
              this.billToPartyEditAction(
                this.state.showEditVatPartnersModal,
                false,
              );
            }}
            btnTitle1={
              this.state.showEditVatPartnersModal
                ? 'Edit Bill To Party and VAT Partners'
                : 'Edit Bill To Party'
            }
            btnTitle2={'Cancel'}
          >
            <p>
              {this.state.isMciFlow
                ? validationMessages.CostAndRevenue.Error_MCI_Blocked
                : validationMessages.CostAndRevenue.Error_Amendment_Blocked}
            </p>
            <p>
              If you wish to edit only the Bill To Party, please click{' '}
              {this.state.showEditVatPartnersModal
                ? 'Edit Bill To Party and VAT Partners'
                : 'Edit Bill To Party'}{' '}
              to continue. If you wish to cancel, click 'Cancel' to remain on
              the current page.
            </p>
          </ModalMain>
        )}
        {this.state.showIcpVatPartnerChoiceModal &&
          (() => {
            const allowIcpVatPartnerDetermination = isFeatureEnabled(
              FEATURE_TOGGLES.FINOPS_ICP_VAT_PARTNER_DETERMINATION,
              this.props.featureToggles,
            );
            const hasJobCostingExecutePermission =
              this.props.userPermissions?.permissions?.some(
                (permission: any) =>
                  permission.businessCapabilityName ===
                    'FinOps (Job Costing)' &&
                  permission.permission === 'Execute',
              );

            // If VAT Partner button is not shown, use standard modal with single primary action
            if (!allowIcpVatPartnerDetermination) {
              return (
                <ModalMain
                  height={300}
                  modal={this.state.showIcpVatPartnerChoiceModal}
                  title={'Operation not possible'}
                  hideMethod={() =>
                    this.setState({ showIcpVatPartnerChoiceModal: false })
                  }
                  secondaryMethod={() =>
                    this.setState({ showIcpVatPartnerChoiceModal: false })
                  }
                  primaryMethod={() => {
                    this.setState({ showIcpVatPartnerChoiceModal: false });
                    this.billToPartyEditAction(false, false);
                  }}
                  btnTitle1={'Edit Bill To Party'}
                  btnTitle2={'Cancel'}
                >
                  <p>
                    {validationMessages.CostAndRevenue.Error_Amendment_Blocked}
                  </p>
                  <p>
                    If you wish to edit only the Bill To Party, please click
                    Edit Bill To Party to continue. If you wish to cancel, click
                    'Cancel' to remain on the current page.
                  </p>
                </ModalMain>
              );
            }

            // With VAT Partner button we need three footer buttons, but ModalMain only
            // supports two and always renders its own footer. The icpVatChoiceModal
            // wrapper lets custom.css hide that footer and style the custom one below.
            return (
              <div className="icpVatChoiceModal">
                <ModalMain
                  height={300}
                  modal={this.state.showIcpVatPartnerChoiceModal}
                  title={'Operation not possible'}
                  hideMethod={() =>
                    this.setState({ showIcpVatPartnerChoiceModal: false })
                  }
                >
                  <p>
                    {validationMessages.CostAndRevenue.Error_Amendment_Blocked}
                  </p>
                  <p>
                    If you wish to edit only Bill To Party or only VAT Partner,
                    please choose one option below. If you wish to cancel, click
                    'Cancel' to remain on the current page.
                  </p>
                  <div className="modal-footer">
                    <Button
                      buttonType={ButtonType.Transparent}
                      onClick={() =>
                        this.setState({ showIcpVatPartnerChoiceModal: false })
                      }
                    >
                      Cancel
                    </Button>
                    <Button
                      buttonType={ButtonType.Blue}
                      onClick={() => {
                        if (!hasJobCostingExecutePermission) {
                          this.setState({
                            showIcpVatPartnerChoiceModal: false,
                            showErrorModal: true,
                            showVatPartnerPermissionError: true,
                          });
                          return;
                        }
                        this.setState({ showIcpVatPartnerChoiceModal: false });
                        this.billToPartyEditAction(true, true);
                      }}
                    >
                      Edit Vat Partner
                    </Button>
                    <Button
                      buttonType={ButtonType.Blue}
                      onClick={() => {
                        this.setState({ showIcpVatPartnerChoiceModal: false });
                        this.billToPartyEditAction(false, false);
                      }}
                    >
                      Edit Bill To Party
                    </Button>
                  </div>
                </ModalMain>
              </div>
            );
          })()}
        <StatusRow title={this.props.tableTitle} id={this.props.id}>
          {this.props.isLoading && <LoadingAnimation smallLoad={true} />}
          <div
            id={this.props.id}
            className={this.addPermissionCheck() ? '' : 'status-block'}
            ref={this.refTable}
          >
            <DataTable
              key={columnSignature}
              isAutoResetColumns={true}
              data={tableRowData}
              columns={columns}
              subColumns={this.props.subCols}
              isEditable={this.props.isEditable}
              isExpandable={
                this.props.isExpandable ? this.props.isExpandable : false
              }
              isSelectable={this.props.readOnly ? false : true}
              selectedOption="multiple"
              manualPagination={false}
              isSortable={true}
              isResizable={true}
              hasFooter={true}
              ref={this.selectTable}
              showColumnOptions={true}
              linkAction={(e: any) => {
                this.openLinkAction(e);
              }}
              tableName={`BookingTableCostRevenue BookingTable${this.props.type}`}
              showPagination={true}
              actions={this.props.readOnly ? null : this.state.actions}
              fetchData={this.fetchOrderData}
            />
          </div>
        </StatusRow>
      </div>
    );
  }
  public getReasonCodes = () => (
    <>
      <div className="padding-top-large">
        <DataList
          id="reasonCode"
          label={'Reason Code'}
          value={this.state.reasonCodeSelected}
          onChange={(e: any) => this.setState({ reasonCodeSelected: e })}
          hasError={!this.state.validReason}
          error={!this.state.validReason ? 'Field is Required' : ''}
          data={
            this.props.reasonCodes &&
            mapReasonCodesToOptions(this.props.reasonCodes)
          }
        />
      </div>
    </>
  );
  public addEventHandler = () => {
    document
      .querySelector(`#${this.props.id} .pagination button`)!
      .addEventListener('click', this.clickEventHandler);
  };

  public clickEventHandler = () => {
    const t = document.querySelector(`#${this.props.id} .modal-dialog`);
    if (t) {
      t.querySelector('button.button-blue')!.addEventListener('click', () => {
        setTimeout(() => {
          this.updateFooter();
        }, 500);
      });
    } else {
      setTimeout(this.clickEventHandler, 1000);
    }
  };
  public updateFooter = () => {
    if (
      document.querySelector(`#${this.props.id} .rt-tfoot .totalLocalCurrency`)
    ) {
      const el = document
        .querySelector(`#${this.props.id} .rt-tfoot .totalLocalCurrency div`)!
        .querySelector('span.data') as HTMLSpanElement;
      if (el) {
        el.innerHTML = calculateTotalOfField(
          this.props.data,
          localCurrency.totalLocalCurrency,
        );
      }
    }
  };

  public isExportJobsDetails = () => {
    return (
      this.props.funcName === 'fcr' &&
      window.location.href.includes('/exportjobs')
    );
  };
  public isEtsDetails = () => {
    return (
      this.props.funcName === 'ets' && window.location.href.includes('/ets')
    );
  };

  public getEditMsg = () => {
    if (this.state.showFrnReadOnlyError) {
      return this.state.isDelete
        ? validationMessages.CostAndRevenue.Error_FRN_ReadOnly_Delete
        : validationMessages.CostAndRevenue.Error_FRN_ReadOnly;
    }
    if (this.state.showFrnMixedDivisionError) {
      return validationMessages.CostAndRevenue.Error_FRN_Mixed_Division;
    }
    if (this.state.showMciDivisionDeleteError) {
      return validationMessages.CostAndRevenue.Error_MCI_Division_Delete;
    }
    if (this.state.showVatPartnerPermissionError) {
      return validationMessages.CostAndRevenue.Error_Vat_Partner_Permission;
    }
    if (this.state.showDifferentTypeSelectionError) {
      return validationMessages.CostAndRevenue.Error_Multiple_Charge_Type;
    }
    if (this.state.showAmendMentError) {
      return validationMessages.CostAndRevenue.Error_Amendment_Blocked;
    }
    if (this.state.isAthenaAmendment) {
      return this.state.isDelete
        ? validationMessages.CostAndRevenue
            .Alert_Charge_locked_delete_isAthenaAmendmentEnabled
        : validationMessages.CostAndRevenue
            .Alert_Charge_locked_isAthenaAmendmentEnabled;
    }
    if (this.state.isDifferentFunc) {
      return this.state.isDelete
        ? validationMessages.CostAndRevenue.Alert_Charge_locked_delete
        : validationMessages.CostAndRevenue.Alert_Charge_locked;
    }
    if (
      this.state.isInvoice &&
      !this.state.isInvoiceError &&
      !this.props.isJobClosed
    ) {
      if (this.state.showInvoiceBlockedError) {
        return validationMessages.InvoiceMessages.Error_Invoice_Blocked;
      }
      if (this.state.showZeroLocalAmountError) {
        return validationMessages.InvoiceMessages.Error_Zero_Local_Amount;
      }
      return validationMessages.InvoiceMessages.Error_Select_BillToParty;
    }
    if (this.state.isInvoiceError) {
      return validationMessages.InvoiceMessages.Error_error_lines;
    }
    if (this.props.isJobClosed) {
      return this.state.isInvoice
        ? validationMessages.CostAndRevenue.Error_Job_Close_Invoice
        : validationMessages.CostAndRevenue.Error_Job_Close;
    }
    const data: any =
      this.selectTable && this.selectTable.current
        ? this.selectTable.current?.getSelectedItems()
        : null;
    if (FinOpsStatusPermission(this.props.finOpsStatus, data)) {
      return this.state.isDelete
        ? validationMessages.CostAndRevenue.Alert_Charge_locked_delete
        : validationMessages.CostAndRevenue.Alert_Charge_locked;
    }
    return this.state.isDelete
      ? validationMessages.CostAndRevenue.Alert_Charge_locked_delete
      : validationMessages.CostAndRevenue.Alert_Status_Charge_locked;
  };
  public addPermissionCheck = () => {
    const { featureToggles, finOpsStatus } = this.props;
    const isSalesOrderRequested =
      finOpsStatus[0] === FinOpsStatus.salesOrderRequested;
    const hasRateErrorMessage = this.props.isDestination
      ? this.props.etsRateErrorMessage
      : this.props.exportRateErrorMessage;
    const isSendCreateSalesOrderEnabled = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_FINANCE_OUTBOUND_REQUESTS,
      featureToggles,
    );

    if (
      isSendCreateSalesOrderEnabled &&
      isSalesOrderRequested &&
      hasRateErrorMessage
    ) {
      return true;
    }
    const checkCBLEq = location.href.indexOf('equipments') > -1;

    if (this.props.isDestination) {
      if (this.props.isJobClosed) {
        return false;
      }
    }
    if (this.props.salesOrderResponse.length === 1) {
      if (this.props.isJobClosed) {
        return false;
      }
    } else if (
      this.props.salesOrderResponse.length > 1 &&
      this.props.type === 'REV'
    ) {
      if (
        this.props.salesOrderResponse.filter(
          (item: any) =>
            item.triggeredByDocumentType === 'FCR' &&
            item.isClosed === 'CLOSED',
        ).length > 0
      ) {
        return false;
      }
    }
    if (
      location.href.indexOf('cbls') > -1 ||
      (!checkCBLEq && FinOpsStatusPermission(this.props.finOpsStatus, null))
    ) {
      return true;
    }
    return false;
  };

  public fullPermissionCheck = (data: any[]) => {
    const checkOpen = FinOpsStatusPermission(
      this.props.finOpsStatus,
      data,
      this.props.type,
    );
    if (checkOpen) {
      return true;
    }
    return false;
  };
  public fetchOrderData = (t: any) => {
    if (this.props.fetchData && t.sorted && t.sorted[0]) {
      const dataType =
        t.sorted && t.sorted[0]
          ? this.getCols().find(
              (column: any) => column.accessor === t.sorted[0].id,
            )?.dataType
          : '';
      this.props.fetchData(this.props.type, t, dataType);
    }
  };
  public getCols = (): any => {
    const isPoReconciliationEnabled = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_RECONCILIATION,
      this.props.featureToggles,
    );
    const showServiceProvider = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ATHENA_PAYTOPARTY_FOR_ADHOC_CONTRACTUAL_RATE_DERIVATION,
      this.props.featureToggles,
    );
    const enableBlockedType = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION,
      this.props.featureToggles,
    );
    const isMciChargeEnabled = this.props.isDestination
      ? isFeatureEnabled(
          FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED,
          this.props.featureToggles,
        )
      : isFeatureEnabled(
          FEATURE_TOGGLES.EXPORT_MCI_CHARGE_ENABLED,
          this.props.featureToggles,
        );
    const isSyngentaShipment =
      this.props.customerToggle?.[0]?.isSyngentaShipment || false;
    const hasEquipmentChargeLevel =
      this.props.data?.some((item: any) => item.chargeLevel === 'Equipment') ||
      false;
    const is4PLChargeLevelEnabled =
      isSyngentaShipment && hasEquipmentChargeLevel;
    // IRN is an Export-only, Revenue-only column
    const isNonStandardFcrEnabled =
      !this.props.isDestination &&
      this.props.type === 'REV' &&
      isFeatureEnabled(
        FEATURE_TOGGLES.FINOPS_KMART_WSI_NON_STANDARD_FCR,
        this.props.featureToggles,
      );
    const isExportJobOrEtsDetails =
      this.isExportJobsDetails() || this.isEtsDetails();
    // Cost-side Trigger Document, on the same receiving CFS gate as the Order Management tab
    const showReceivingTriggerDocument =
      Boolean(this.props.isNftpBillable) &&
      Boolean(this.props.isReceivingFCR) &&
      isFeatureEnabled(
        FEATURE_TOGGLES.FINOPS_RECEIVING_FCR,
        this.props.featureToggles,
      );
    const cols = originDestinationCols(
      this.props.isDestination,
      this.props.type,
      isExportJobOrEtsDetails,
      this.props.isSourceAthena,
      this.props.isReceivingFCR,
      isPoReconciliationEnabled,
      showServiceProvider,
      enableBlockedType,
      this.props.isNftpBillable,
      this.props.isNftpRoeEnabled,
      isMciChargeEnabled,
      is4PLChargeLevelEnabled,
      isNonStandardFcrEnabled,
      showReceivingTriggerDocument,
    );
    // billingDate is defined show:true in CostColumnsData for every caller; this table alone
    // re-gates it for NFTP-billable rows behind FINOPS_BPD_ENGINE (ISCMLP-151900) - same set of
    // screens (booking, equipment, documents, CBLs, export job, ETS) that the pre-existing
    // isNftpBillable suppression applied to. Non-NFTP-billable rows keep the legacy
    // always-visible behavior on every screen.
    const billingDateCol = cols.find((col: any) => col.accessor === 'billingDate');
    if (billingDateCol && this.props.isNftpBillable) {
      billingDateCol.show = isFeatureEnabled(
        FEATURE_TOGGLES.FINOPS_BPD_ENGINE,
        this.props.featureToggles,
      );
    }
    return cols;
  };
  public addFc = () => {
    this.setState({ showModal: false, showDialog: false, errorMessage: '' });
    this.props.addAction(this.selectTable.current);
  };
  public checkDeletePermission = async () => {
    const data: any = this.selectTable.current.getSelectedItems();

    // FRN/MCI read-only check: gated behind import/export feature flags
    const isMciChargeEnabled = this.props.isDestination
      ? isFeatureEnabled(
          FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED,
          this.props.featureToggles,
        )
      : isFeatureEnabled(
          FEATURE_TOGGLES.EXPORT_MCI_CHARGE_ENABLED,
          this.props.featureToggles,
        );
    if (isMciChargeEnabled) {
      const hasFrnReadOnly = data.some((obj: any) => obj.isReadOnly === true);
      if (hasFrnReadOnly) {
        this.setState({
          showErrorModal: true,
          showModal: false,
          showFrnReadOnlyError: true,
          isDelete: true,
        });
        return;
      }
      // REV charges in the MCI division cannot be deleted from the UI
      if (this.props.type === 'REV') {
        const hasMciDivision = data.some((obj: any) => obj.division === 'MCI');
        if (hasMciDivision) {
          this.setState({
            showErrorModal: true,
            showModal: false,
            showMciDivisionDeleteError: true,
            isDelete: true,
          });
          return;
        }
      }
    }

    let consigneePermission = true;
    const itemsIncludeAthena =
      this.props.isSourceAthena &&
      data.some((obj: any) => obj.itemType === ATHENA);
    if (itemsIncludeAthena) {
      consigneePermission = await this.getConsigneePermissions();
    }
    const allSameFunc = this.isExportJobsDetails()
      ? data.every((obj: any) => obj.viewAdded === pageName.EXPORT_JOB)
      : true;
    const isAthenaToggleDisabled = itemsIncludeAthena && !consigneePermission;
    if (!allSameFunc || isAthenaToggleDisabled) {
      // getEditMsg reads isAthenaAmendment before isDifferentFunc, so only flag the customer
      // toggle when the view check passed - otherwise the view mismatch is the real blocker.
      this.setState({
        isAthenaAmendment: allSameFunc && isAthenaToggleDisabled,
        showErrorModal: true,
        showModal: false,
        isDifferentFunc: !allSameFunc,
        isDelete: true,
      });
    } else if (this.props.isJobClosed) {
      this.setState({ showErrorModal: true, showModal: false });
    } else {
      const notItemNumber = () => {
        let bol: boolean = false;
        data.forEach((el: any) => {
          if (!el.itemNumber && !checkIfSystemType([el])) {
            bol = true;
          }
        });
        return bol;
      };
      const hasItemNumber = (bol = true) => {
        let resp: boolean = false;
        data.forEach((el: any) => {
          const checkVal = bol ? el.itemNumber : !el.itemNumber;
          if (checkVal) {
            resp = true;
          }
        });
        return resp;
      };
      const editCheck =
        this.fullPermissionCheck(this.selectTable.current.getSelectedItems()) &&
        !checkLinkedState(this.selectTable.current.getSelectedItems());
      const check =
        (notItemNumber() ||
          (FinOpsStatusSalesOrder(data) && hasItemNumber() && editCheck)) &&
        (hasItemNumber() ||
          (!checkIfSystemType(data) && hasItemNumber(false) && editCheck));
      if (check || this.fullPermissionCheck(data)) {
        this.setState({
          showModal: true,
          showErrorModal: false,
          isDelete: true,
        });
      } else {
        this.setState({
          showErrorModal: true,
          showModal: false,
          isDelete: true,
        });
      }
    }
  };
  public deleteFc = async (ignoreOnRefresh?: string) => {
    const data: any = this.selectTable.current;
    const selectedItems = data.getSelectedItems();
    const haveSomeInsertedAndUpdatedByAthena = selectedItems?.some(
      (item: any) => item.insertBy === ATHENA,
    );
    if (haveSomeInsertedAndUpdatedByAthena && !ignoreOnRefresh) {
      this.setState({ ignoreOnRefreshRequired: true });
      return;
    }
    if (ignoreOnRefresh) {
      selectedItems.forEach((item: any) => {
        if (item.insertBy === ATHENA) {
          item.IsIgnoredOnRateRefresh = ignoreOnRefresh === 'Y' ? true : false;
        }
      });
    }
    if (
      this.fullPermissionCheck(data.getSelectedItems()) &&
      !checkLinkedState(data.getSelectedItems())
    ) {
      if (this.state.reasonCodeSelected) {
        this.setState({
          validReason: true,
          showModal: false,
          showErrorModal: false,
          showDialog: false,
          errorMessage: '',
          isDelete: true,
        });
        this.props.deleteAction(selectedItems, this.state.reasonCodeSelected);
        this.clearSelection();
      } else {
        this.setState({ validReason: false });
      }
    } else {
      // extra check
      this.setState({ showErrorModal: true, showModal: false, isDelete: true });
    }
  };

  public showIgnoreOnRefreshSelection = () => {
    const data: any = this.selectTable.current;
    const selectedItems = data?.getSelectedItems();
    const haveSomeInsertedAndUpdatedByAthena = selectedItems?.some(
      (item: any) => item.insertBy === ATHENA,
    );
    if (haveSomeInsertedAndUpdatedByAthena) {
      return true;
    }
    return false;
  };

  public clearSelection = () => {
    const currSelected: ITableSelected = this.selectTable
      .current as ITableSelected;
    for (const sElement of currSelected.getSelectedItems()) {
      currSelected
        .getData()
        .splice(currSelected.getData().indexOf(sElement), 1);
    }
    currSelected.hideContextRibbon();
    this.setState({ reasonCodeSelected: '' });
  };

  public editFc = async () => {
    const { featureToggles, finOpsStatus } = this.props;
    const enableBlockedType = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION,
      featureToggles,
    );
    const isSendCreateSalesOrderEnabled = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_FINANCE_OUTBOUND_REQUESTS,
      featureToggles,
    );
    const isSalesOrderRequested =
      finOpsStatus[0] === FinOpsStatus.salesOrderRequested;
    const hasRateErrorMessage = this.props.isDestination
      ? this.props.etsRateErrorMessage
      : this.props.exportRateErrorMessage;
    let consigneePermission = false;
    const hasPermissions = this.props.userPermissions.permissions.some(
      (permission: any) =>
        permission.businessCapabilityName === 'FinOps (Job Costing)' &&
        permission.permission === 'Execute',
    );
    const data: any = this.selectTable.current;
    const selectedItems = data.getSelectedItems();
    const allowEditVatPartner = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ENABLE_VATPARTNER_AMENDMENT,
      featureToggles,
    );

    // FRN/MCI checks: gated behind import/export feature flags
    const isMciChargeEnabled = this.props.isDestination
      ? isFeatureEnabled(
          FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED,
          featureToggles,
        )
      : isFeatureEnabled(
          FEATURE_TOGGLES.EXPORT_MCI_CHARGE_ENABLED,
          featureToggles,
        );

    if (isMciChargeEnabled) {
      // FRN read-only check: if any selected item has isReadOnly = true, block edit entirely
      const hasFrnReadOnly = selectedItems.some(
        (obj: any) => obj.isReadOnly === true,
      );
      if (hasFrnReadOnly) {
        this.setState({
          showErrorModal: true,
          showModal: false,
          showFrnReadOnlyError: true,
        });
        return;
      }

      // FRN division check (REV only): block mixed division selections, route MCI division to bill-to-party-only edit
      if (this.props.type === 'REV') {
        const hasFrnDivisionOne = selectedItems.some(
          (obj: any) => obj.division === 'MCI',
        );
        const hasFrnDivisionTwo = selectedItems.some(
          (obj: any) => obj.division === 'SCM',
        );
        if (hasFrnDivisionOne && hasFrnDivisionTwo) {
          this.setState({
            showErrorModal: true,
            showModal: false,
            showFrnMixedDivisionError: true,
          });
          return;
        }
        if (hasFrnDivisionOne) {
          const areAllSameFunc = this.isExportJobsDetails()
            ? selectedItems.every(
                (obj: any) => obj.viewAdded === pageName.EXPORT_JOB,
              )
            : true;
          this.setState({ isMciFlow: true });
          this.checkEditConditions(
            data,
            areAllSameFunc,
            true,
            true,
            false,
            // Job Costing Execute permission must gate VAT Partner editing here too, same as the non-MCI path
            allowEditVatPartner && hasPermissions,
          );
          return;
        }
      }
    }

    // division = 2 or no FRN properties: continue with existing flow
    const isAmendMentBlocked = selectedItems.some(
      (obj: any) => obj.blockedType === BLOCKED_TYPES.AMENDMENT,
    );
    const nonAmendmentBlocked = selectedItems.some(
      (obj: any) => obj.blockedType !== BLOCKED_TYPES.AMENDMENT,
    );
    const allSameFunc = this.isExportJobsDetails()
      ? selectedItems.every((obj: any) => obj.viewAdded === pageName.EXPORT_JOB)
      : true;
    const itemsIncludeAthena =
      this.props.isSourceAthena &&
      selectedItems.some((obj: any) => obj.itemType === ATHENA);
    const athenaEditedByUser =
      itemsIncludeAthena &&
      selectedItems.every((obj: any) => obj.updatedBy !== ATHENA);
    const allowIcpVatPartnerDetermination = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ICP_VAT_PARTNER_DETERMINATION,
      this.props.featureToggles,
    );
    const systemUsers = ['ATHENA'];
    const isInsertedByUser = selectedItems.every(
      (obj: any) => !systemUsers.includes(obj.insertBy),
    );

    if (isInsertedByUser) {
      if (enableBlockedType && isAmendMentBlocked) {
        if (nonAmendmentBlocked) {
          this.setState({
            showErrorModal: true,
            showModal: false,
            showDifferentTypeSelectionError: true,
          });
        } else {
          this.checkEditConditions(
            data,
            allSameFunc,
            true,
            true,
            this.props.type === 'REV' && allowIcpVatPartnerDetermination,
          );
        }
      } else {
        this.checkEditConditions(data, allSameFunc, true, false);
      }
    } else {
      if (itemsIncludeAthena) {
        consigneePermission = await this.getConsigneePermissions();
      }
      if (
        isSendCreateSalesOrderEnabled &&
        isSalesOrderRequested &&
        hasRateErrorMessage
      ) {
        this.setState({
          showModal: false,
          showDialog: false,
          errorMessage: '',
        });
        this.props.editAction([...data.getSelectedItems()]);
      } else if (itemsIncludeAthena && !athenaEditedByUser) {
        if (consigneePermission) {
          if (enableBlockedType && isAmendMentBlocked) {
            if (nonAmendmentBlocked) {
              this.setState({
                showErrorModal: true,
                showModal: false,
                showDifferentTypeSelectionError: true,
              });
            } else {
              this.checkEditConditions(
                data,
                allSameFunc,
                true,
                true,
                this.props.type === 'REV' && allowIcpVatPartnerDetermination,
              );
            }
          } else {
            this.checkEditConditions(data, allSameFunc, true, false);
          }
        } else if (
          allowEditVatPartner &&
          !consigneePermission &&
          this.props.type === 'REV' &&
          hasPermissions
        ) {
          this.checkEditConditions(data, allSameFunc, false, false);
        } else {
          if (enableBlockedType && isAmendMentBlocked) {
            if (nonAmendmentBlocked) {
              this.setState({
                showErrorModal: true,
                showModal: false,
                showDifferentTypeSelectionError: true,
              });
            } else {
              this.checkEditConditions(
                data,
                allSameFunc,
                true,
                true,
                this.props.type === 'REV' && allowIcpVatPartnerDetermination,
              );
            }
          } else {
            this.setState({
              showErrorModal: true,
              showModal: false,
              isAthenaAmendment: true,
            });
          }
        }
      } else {
        if (enableBlockedType && isAmendMentBlocked) {
          if (nonAmendmentBlocked) {
            this.setState({
              showErrorModal: true,
              showModal: false,
              showDifferentTypeSelectionError: true,
            });
          } else {
            this.checkEditConditions(
              data,
              allSameFunc,
              true,
              true,
              this.props.type === 'REV' && allowIcpVatPartnerDetermination,
            );
          }
        } else {
          this.setState({ isAthenaAmendment: false });
          this.checkEditConditions(data, allSameFunc, true, false);
        }
      }
    }
  };

  public checkEditConditions(
    data: any,
    allSameFunc: boolean,
    consigneePermission: boolean,
    billToPartyEdit: boolean,
    showIcpVatChoice: boolean = false,
    enableVatPartnerEdit: boolean = false,
  ) {
    if (!allSameFunc) {
      this.setState({
        showErrorModal: true,
        showModal: false,
        isDifferentFunc: true,
      });
    } else if (this.props.isJobClosed) {
      this.setState({ showErrorModal: true, showModal: false });
    } else {
      if (
        this.fullPermissionCheck(data.getSelectedItems()) &&
        !checkLinkedState(data.getSelectedItems())
      ) {
        if (!consigneePermission) {
          this.setState({
            showEditVatPartnersModal: true,
            showErrorModal: false,
            showModal: false,
            isAthenaAmendment: false,
            showIcpVatPartnerChoiceModal: false,
          });
        } else if (showIcpVatChoice) {
          this.setState({
            showIcpVatPartnerChoiceModal: true,
            showErrorModal: false,
            showModal: false,
            isAthenaAmendment: false,
            showEditVatPartnersModal: false,
            allowBillToPartyEdit: false,
          });
        } else if (billToPartyEdit) {
          this.setState({
            allowBillToPartyEdit: true,
            showErrorModal: false,
            showModal: false,
            isAthenaAmendment: false,
            showIcpVatPartnerChoiceModal: false,
            // MCI flow passes enableVatPartnerEdit so VAT Partner can be edited alongside Bill To Party
            showEditVatPartnersModal: enableVatPartnerEdit,
          });
        } else {
          this.setState({
            showModal: false,
            showDialog: false,
            errorMessage: '',
            showIcpVatPartnerChoiceModal: false,
          });
          this.props.editAction([...data.getSelectedItems()]);
        }
      } else {
        this.setState({ showErrorModal: true, showModal: false });
      }
    }
  }

  public canBeInvoiced = (list: any[]): boolean => {
    const compareTo: any = {
      billToParty: '',
    };
    let returnBol: boolean = true;
    let hasError: boolean = false;
    list.forEach((item: any, index: number) => {
      if (index === 0) {
        compareTo.billToParty = item.billToParty;
        if (item.errorReason) {
          hasError = true;
        }
        if (
          item.status !== 'Linked to Sales Order' ||
          !item.rate ||
          item.rate === 0 ||
          !item.uom
        ) {
          returnBol = false;
        }
      } else {
        if (item.errorReason) {
          hasError = true;
        }
        if (
          compareTo.billToParty !== item.billToParty ||
          item.status !== 'Linked to Sales Order' ||
          !item.rate ||
          item.rate === 0 ||
          !item.uom
        ) {
          returnBol = false;
        }
      }
    });
    if (hasError) {
      returnBol = false;
      this.setState({ showErrorModal: true, isInvoiceError: true });
    }
    return returnBol;
  };

  public validateAndIssueInvoice = async (selectedItems: any[]) => {
    this.setState({ isValidatingInvoice: true });
    try {
      const rawDocumentId = this.props.isDestination
        ? this.props.etsNumber
        : this.props.exportJobNumber;
      const documentId = Number(rawDocumentId);
      if (!Number.isFinite(documentId) || documentId <= 0) {
        this.setState({
          isValidatingInvoice: false,
          showDialog: true,
          errorMessage: 'Invalid document id. Unable to validate invoice.',
        });
        return;
      }

      const documentIds = [documentId];
      const category = this.props.isDestination ? 'ISSO' : 'ESSO';

      const response = await callApiV3Post(API.Invoices.ValidateInvoice, {
        documentIds,
        category,
      });
      const validationResult = response && response.data;

      if (validationResult && validationResult.isValid) {
        this.setState({
          showInvoiceValidationModal: false,
          invoiceValidationErrors: [],
        });
        this.proceedWithInvoice(selectedItems);
      } else {
        this.setState({
          showInvoiceValidationModal: true,
          invoiceValidationErrors:
            validationResult && Array.isArray(validationResult.errors)
              ? validationResult.errors
              : [],
          isValidatingInvoice: false,
        });
      }
    } catch (e) {
      const error = e as Error;
      this.setState({
        isValidatingInvoice: false,
        showDialog: true,
        errorMessage:
          error && error.message
            ? `Invoice validation failed: ${error.message}`
            : 'Invoice validation failed. Please try again.',
      });
    }
  };

  public proceedWithInvoice = (selectedItems: any[]) => {
    this.setState({ isValidatingInvoice: false });
    if (this.props.setSelectedInvoices) {
      let queryParams = {};
      const consignee = this.props.billToPartnersRawData.find(
        (partner: any) => partner.partnerType === 'Consignee',
      );

      if (this.props.isDestination) {
        // ets
        queryParams = new URLSearchParams({
          documentNumber: this.props.etsDocumentNumber,
          documentId: this.props.etsNumber,
          billToParty: selectedItems[0].billToParty,
          consignee: consignee && consignee.factCode ? consignee.factCode : '',
          icbIndicator: selectedItems[0].icbIndicator,
          billingCurrency: selectedItems[0].localCurrency,
          status: selectedItems[0].status,
          companyCode: this.props.destinationCompanyCode,
          charges: selectedItems.map((item: any) => item.chargeItem).join(','),
        }).toString();
      } else {
        // export job
        queryParams = new URLSearchParams({
          documentNumber: this.props.exportDocumentNumber,
          documentId: this.props.exportJobNumber,
          billToParty: selectedItems[0].billToParty,
          consignee: consignee && consignee.factCode ? consignee.factCode : '',
          icbIndicator: selectedItems[0].icbIndicator,
          billingCurrency: selectedItems[0].localCurrency,
          status: selectedItems[0].status,
          companyCode: this.props.originCompanyCode,
          charges: selectedItems.map((item: any) => item.chargeItem).join(','),
        }).toString();
      }
      redirectToCombineInvoice(
        this.props.isDestination ? 'destination' : 'origin',
        queryParams,
      );
    }
  };

  public issueFc = () => {
    const enableBlockedType = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION,
      this.props.featureToggles,
    );
    const isPreInvoiceValidationEnabled = isFeatureEnabled(
      FEATURE_TOGGLES.FINOPS_PRE_INVOICE_VALIDATION,
      this.props.featureToggles,
    );
    const data: any = this.selectTable.current;
    const selectedItems: any[] = data.getSelectedItems();
    const isInvoiceBlocked = selectedItems.some(
      (obj: any) => obj.blockedType === BLOCKED_TYPES.INVOICE,
    );
    const hasZeroLocalAmount = selectedItems.some(
      (obj: any) =>
        obj.totalLocalCurrency === 0 ||
        obj.totalLocalCurrency === null ||
        obj.totalLocalCurrency === undefined,
    );
    if (enableBlockedType && isInvoiceBlocked) {
      this.setState({
        showErrorModal: true,
        showModal: false,
        isInvoice: true,
        showInvoiceBlockedError: true,
      });
    } else if (hasZeroLocalAmount) {
      this.setState({
        showErrorModal: true,
        showModal: false,
        isInvoice: true,
        showZeroLocalAmountError: true,
      });
    } else if (this.props.isJobClosed) {
      this.setState({
        showErrorModal: true,
        showModal: false,
        isInvoice: true,
      });
    } else if (this.canBeInvoiced(selectedItems)) {
      if (selectedItems && selectedItems.length > 0) {
        if (isPreInvoiceValidationEnabled) {
          this.validateAndIssueInvoice(selectedItems);
        } else {
          this.proceedWithInvoice(selectedItems);
        }
      }
    } else {
      this.setState({
        showErrorModal: true,
        isInvoice: true,
      });
    }
  };
  public vatPartnersEditAction = () => {
    // const data: any = this.selectTable.current;
    // const selectedItems: any[] = data.getSelectedItems();
    // this.props.setRowData(selectedItems);

    if (this.props.vatPartnersEdit) {
      const data: any = this.selectTable.current;
      const selectedItems: any[] = data.getSelectedItems();
      this.props.setVatPartnersTableData({
        columns: this.getCols(),
        data: selectedItems,
        vendorsData: this.props.vendorsData,
        category: this.props.isDestination ? 'ISSO' : 'ESSO',
      });
      this.props.fetchVatPartners();
      this.props.fetchVatPartnerEditReasons();
      this.props.vatPartnersEdit();
    }
  };

  public billToPartyEditAction = (
    enableVatFields: boolean = this.state.showEditVatPartnersModal,
    editVatOnlyMode: boolean = false,
  ) => {
    if (this.props.billToPartyEdit) {
      const data: any = this.selectTable.current;
      const selectedItems: any[] = data.getSelectedItems();
      this.props.setRowData(selectedItems);
      this.props.setTargetType(
        this.props.isDestination ? 'destination' : 'origin',
      );
      this.props.setJobId(this.props.vendorsData.costAndRevenueId);
      this.props.setTarget(this.props.vendorsData.targetId);
      if (enableVatFields) {
        this.props.fetchVatPartners();
        this.props.fetchVatPartnerEditReasons();
        this.props.setEditVatMode(true);
      } else {
        this.props.setEditVatMode(false);
      }
      if (this.props.setEditVatOnlyMode) {
        this.props.setEditVatOnlyMode(editVatOnlyMode);
      }
      this.props.billToPartyEdit();
    }
  };

  public openLinkAction = (item: any) => {
    const documentLink = `https://scm${process.env.NODE_ENV?.toLowerCase() !== 'production' ? `-${process.env.NODE_ENV}` : ''}.maersk.com/scp/cshub/payables/section/purchase-orders/purchaseOrders/details/${item.reconsiliationPODetails}`;
    this.openInNewTab(documentLink);
  };

  public openInNewTab = (url: string) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  private getConsigneePermissions = async () => {
    // customerToggle is pre-fetched in componentDidUpdate when billToPartnersRawData arrives.
    // Reading it directly avoids dispatching PENDING (which clears the slice, mutates
    // columnSignature, and remounts the DataTable - perceived as a page refresh).
    if (this.props.customerToggle && this.props.customerToggle.length > 0) {
      return (
        this.props.customerToggle[0]?.isAthenaPricedAmendmentEnabled || false
      );
    }

    // Fallback: data not yet pre-fetched (e.g. billToPartnersRawData not yet arrived).
    let isAthenaPricedAmendmentEnabled = false;
    if (
      this.props.billToPartnersRawData &&
      this.props.billToPartnersRawData.length > 0
    ) {
      const consignee = this.props.billToPartnersRawData
        .filter((partner: any) => partner.partnerType === 'Consignee')
        .map(
          (partner: any) =>
            `${partner.country}${partner.beCode}${partner.funcCode}`,
        );
      if (consignee.length) {
        await this.props.fetchCustomerToggles(consignee[0]);
        isAthenaPricedAmendmentEnabled =
          this.props.customerToggle[0]?.isAthenaPricedAmendmentEnabled || false;
      }
    }
    return isAthenaPricedAmendmentEnabled;
  };

  private setData = (data: any) => {
    if (data && data.length) {
      data = data.map((item: any) => {
        if (
          this.props.reconsiliationPODetails &&
          this.props.reconsiliationPODetails.length > 0 &&
          this.props.type === 'COST'
        ) {
          this.props.reconsiliationPODetails.map((item1: any) => {
            if (
              Number(item1.salesOrderLineItemNumber) === Number(item.itemNumber)
            ) {
              item.reconsiliationPODetails = item1.poNumber;
            }
          });
        }
        return item;
      });
    }
    this.setState({
      localData: data,
    });
  };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
  reasonCodes: state.mdm.reasonCodes,
  featureToggles: state.featureToggle.featureToggles,
  billToPartnersRawData: state.billToParty.partnersRawData,
  customerToggle: state.customerToggle.customerToggle,
  reconsiliationPODetails: state.exportJob.reconsiliationPODetails,
  userPermissions: state.user.userPermissions,
  etsNumber: state.ets.etsDetails.equipmentTransportShipmentId,
  exportJobNumber: state.exportJob.exportJobDetails.documentId,
  etsDocumentNumber: state.ets.etsDetails.documentNumber,
  exportDocumentNumber: state.exportJob.exportJobDetails.originalDocumentNumber,
  originCompanyCode: state.exportJob.exportJobDetails.companyCode,
  destinationCompanyCode: state.ets.etsDetails.companyCode,
  etsRateErrorMessage: state.ets.etsDetails.rateErrorMessage,
  exportRateErrorMessage: state.exportJob.exportJobDetails.rateErrorMessage,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, Action>,
): IMapDispatchToProps => ({
  getReasonCodes: (category: string) => dispatch(getReasonCodes(category)),
  fetchCustomerToggles: (customerBeCode: string) =>
    dispatch(fetchCustomerToggles(customerBeCode)),
  fetchReconciliationPODetails: (exportJobId: number, catagory: number) =>
    dispatch(fetchReconciliationPODetails(exportJobId, catagory)),
  setVatPartnersTableData: (data: any) =>
    dispatch(setVatPartnersTableData(data)),
  fetchVatPartners: () => dispatch(fetchVatPartners()),
  fetchVatPartnerEditReasons: () => dispatch(fetchVatPartnerEditReasons()),
  getAllBillToPartiesAction: (searchId: number, level: number) =>
    dispatch(getAllBillToParties(searchId, level)),
  setRowData: (data: any) => dispatch(setRowData(data)),
  setTargetType: (targetType: string) => dispatch(setTargetType(targetType)),
  setJobId: (jobId: number) => dispatch(setJobId(jobId)),
  setTarget: (targetId: number | string) => dispatch(setTarget(targetId)),
  setEditVatMode: (editVatMode: boolean) =>
    dispatch(setEditVatMode(editVatMode)),
  setEditVatOnlyMode: (editVatOnlyMode: boolean) =>
    dispatch(setEditVatOnlyMode(editVatOnlyMode)),
});
const CostRevTable = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(
  mapStateToProps,
  mapDispatchToProps,
)(_CostRevTable);

export default CostRevTable;
